import { Link } from "react-router-dom";

interface Props {
  to: string;
  label: string;
  icon: string;
}

export default function FeatureCard({ to, label, icon }: Props) {
  return (
    <Link className="feature-card" to={to}>
      <span className="feature-card__icon" aria-hidden="true">{icon}</span>
      {label}
    </Link>
  );
}
